import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import cn from 'classnames';
import { Tooltip } from '../Tooltip/Tooltip.js';
import { IconButton } from '../IconButton/IconButton.js';
import { useGaudiLocalization } from '../Provider/Provider.js';
import { usePopoverState, PopoverDisclosure, Popover, PopoverArrow } from 'reakit/Popover';

var _excluded = ["children", "className", "disclosure", "disclosureTooltip", "onClose", "placement"],
    _excluded2 = ["as"],
    _excluded3 = ["onClick"];
var Hanger = function Hanger(props) {
  var children = props.children,
      className = props.className,
      disclosure = props.disclosure,
      disclosureTooltip = props.disclosureTooltip,
      onClose = props.onClose,
      _props$placement = props.placement,
      placement = _props$placement === void 0 ? 'bottom' : _props$placement,
      otherProps = _objectWithoutPropertiesLoose(props, _excluded);

  var defaultRef = React__default.useRef(typeof document !== 'undefined' ? document.body : null);

  var _useGaudiLocalization = useGaudiLocalization(),
      texts = _useGaudiLocalization.texts;

  var popover = usePopoverState({
    modal: false,
    placement: placement,
    visible: !!disclosure
  });
  var popoverDisclosure = null;

  if (disclosure) {
    // reakit's PopoverDisclosure accepts an `as` prop (not documented) so we need to avoid that
    var _disclosure$props = disclosure.props,
        safeDisclosureProps = _objectWithoutPropertiesLoose(_disclosure$props, _excluded2);

    popoverDisclosure = React__default.createElement(PopoverDisclosure, Object.assign({}, popover, safeDisclosureProps), function (props) {
      // onClick defined by reakit will toggle popover. Hanger should keep its visible state when clicking on its disclosure
      var disclosureProps = _objectWithoutPropertiesLoose(props, _excluded3);

      var button = React__default.cloneElement(disclosure, disclosureProps);
      return disclosureTooltip ? React__default.createElement(Tooltip, {
        title: disclosureTooltip
      }, button) : button;
    });
  }

  return React__default.createElement(React__default.Fragment, null, popoverDisclosure, popover.visible && React__default.createElement(Popover, Object.assign({}, popover, otherProps, {
    className: cn('yt-hanger', className),
    hideOnClickOutside: false,
    unstable_finalFocusRef: disclosure ? undefined : defaultRef
  }), React__default.createElement(PopoverArrow, Object.assign({}, popover, {
    className: "yt-popover__arrow"
  })), React__default.createElement(IconButton, {
    icon: "close",
    appearance: "discrete",
    "aria-label": texts.hanger.close,
    className: "yt-hanger__close",
    onClick: function onClick(event) {
      popover.hide();
      if (onClose) onClose(event);
    }
  }), typeof children === 'function' ? children({
    hide: popover.hide
  }) : children));
};

export { Hanger };
//# sourceMappingURL=Hanger.js.map
